import React, { useState } from "react";
import { Button, Menu, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export default function InvoiceButton({ selection }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const closeWith = (val) => {
        setAnchorEl(null);
        selection(val);
    };

    return (
        <div>
            <Button
                startIcon={<AddIcon />}
                onClick={(e) => setAnchorEl(e.currentTarget)}
                variant="outlined"
                sx={{ minHeight: 36 }}
            >
                Add invoice
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem onClick={() => closeWith('Add Raw Material')}>Add raw material</MenuItem>
                <MenuItem disabled onClick={() => closeWith('Upload New Items')}>Upload new items</MenuItem>
                <MenuItem onClick={() => closeWith('Manually Add Invoice')}>Manually add receipt</MenuItem>
                <MenuItem onClick={() => closeWith('Upload PDF/Image')}>Upload receipt</MenuItem>
            </Menu>
        </div>
    );
}
